// Libs
import _find from 'lodash/find'
import { createSelector } from 'reselect'

// Selectors
import jobs$ from './jobs'
import selectedJobId$ from 'hfty-map/src/selectors/selectedJobId'
// Constants
import {
  PROP_SAMPLING_JOB_ID,
} from 'fc-model-sampling-jobs'

export default createSelector(
  [
    jobs$,
    selectedJobId$,
  ],
  function (jobs, selectedJobId) {
    const selectedJob = _find(jobs, (job) => job[PROP_SAMPLING_JOB_ID] === selectedJobId)
    if (selectedJob) {
      return selectedJob
    }
    return null
  }
)

export function selectedJob (selectedJobId: ?number) {
  return createSelector(
    [
      jobs$,
    ],
    (jobs) => {
      const selectedJob = _find(jobs, (job) => job[PROP_SAMPLING_JOB_ID] === selectedJobId)
      if (selectedJob) {
        return selectedJob
      }
      return null
    }
  )
}
